/**
 * `.c-btn` metrics from the design system (card-system.css:336-337).
 *
 * Shared because these values had already drifted apart across three copies — the editor shell's
 * Cancel/Save, the list's "Add payer" and the delete dialog's actions — and the line-height was
 * corrected in two of them while the third kept MUI's default. One definition means one decision.
 *
 * MUI's Button defaults match on font-size (14px) and weight (500) but NOT line-height: it ships
 * 1.75 against the design's 1, which inside the fixed 40px box pushes the label off the optical
 * centre and reads looser than the hand-off.
 */
export const C_BTN = {
	minHeight: "2.5rem",
	borderRadius: "0.5rem",
	textTransform: "uppercase" as const,
	letterSpacing: "0.04em",
	px: 2,
	fontSize: "0.875rem",
	fontWeight: 500,
	lineHeight: 1,
};

/**
 * `.c-btn--secondary` (card-system.css:346): a brand-OUTLINED button, not MUI's borderless text
 * button. The distinction matters wherever a secondary sits beside a filled destructive action —
 * a text button next to a filled red one does not read as a comparable choice, which quietly
 * biases the user toward the destructive one.
 */
export const C_BTN_SECONDARY = {
	...C_BTN,
	borderColor: "primary.main",
};
